/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementUsersHistoryQueryVariables = Types.Exact<{
  input: Types.BackofficeUserManagementUsersHistoryInput
}>

export type BackofficeUserManagementUsersHistoryQuery = {
  __typename?: 'Query'
  backofficeUserManagementUsersHistory: Array<{
    __typename?: 'BackofficeUserManagementUserHistory'
    id: string
    author: string
    action: string
    affectedAttribute: string
    description: string
    timestamp: string
    userName: string
    email: string
    notes: string
  }> | null
}

export const BackofficeUserManagementUsersHistoryDocument = gql`
    query backofficeUserManagementUsersHistory($input: BackofficeUserManagementUsersHistoryInput!) {
  backofficeUserManagementUsersHistory(input: $input) {
    id
    author
    action
    affectedAttribute
    description
    timestamp
    userName
    email
    notes
  }
}
    `

/**
 * __useBackofficeUserManagementUsersHistoryQuery__
 *
 * To run a query within a React component, call `useBackofficeUserManagementUsersHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementUsersHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserManagementUsersHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementUsersHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  > &
    (
      | {
          variables: BackofficeUserManagementUsersHistoryQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >(BackofficeUserManagementUsersHistoryDocument, options)
}
export function useBackofficeUserManagementUsersHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >(BackofficeUserManagementUsersHistoryDocument, options)
}
// @ts-ignore
export function useBackofficeUserManagementUsersHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserManagementUsersHistoryQuery,
  BackofficeUserManagementUsersHistoryQueryVariables
>
export function useBackofficeUserManagementUsersHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserManagementUsersHistoryQuery,
        BackofficeUserManagementUsersHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserManagementUsersHistoryQuery | undefined,
  BackofficeUserManagementUsersHistoryQueryVariables
>
export function useBackofficeUserManagementUsersHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserManagementUsersHistoryQuery,
        BackofficeUserManagementUsersHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >(BackofficeUserManagementUsersHistoryDocument, options)
}
export type BackofficeUserManagementUsersHistoryQueryHookResult = ReturnType<
  typeof useBackofficeUserManagementUsersHistoryQuery
>
export type BackofficeUserManagementUsersHistoryLazyQueryHookResult =
  ReturnType<typeof useBackofficeUserManagementUsersHistoryLazyQuery>
export type BackofficeUserManagementUsersHistorySuspenseQueryHookResult =
  ReturnType<typeof useBackofficeUserManagementUsersHistorySuspenseQuery>
export type BackofficeUserManagementUsersHistoryQueryResult =
  Apollo.QueryResult<
    BackofficeUserManagementUsersHistoryQuery,
    BackofficeUserManagementUsersHistoryQueryVariables
  >
